module.exports = __webpack_public_path__ + "img/uk.612f7473.svg";